<template>
  <div class="overflow-hidden position-relative items">
    <LoadingWidget v-if="loading" class="py-0 py-md-13 py-lg-16" />

    <transition name="fade">
      <div v-if="!loading && items.length">
        <template v-for="(item, keyItems) in items">
          <ProductCard
            v-bind="item"
            :left="keyItems % 2 == 0"
            :key="keyItems"
          />
        </template>

        <div class="text-center my-8 my-md-12 my-lg-16">
          <ButtonWidget :to="path"> Ver Todos </ButtonWidget>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { formatToURL } from "../../utils/formatToURL";
import LoadingWidget from "../widgets/LoadingWidget.vue";
import ProductCard from "../cards/ProductCard.vue";
import ButtonWidget from "../widgets/ButtonWidget.vue";

const _config = {
  mod: "products",
  path: "/produtos",
};

export default {
  data: () => ({
    loading: true,
    path: _config.path,
    itemsPerPage: 3,
    items: [],
  }),
  created() {
    this.$rest(_config.mod)
      .get({
        params: { itemsPerPage: this.itemsPerPage },
      })
      .then((data) => {
        this.items = data.map(({ id, img, title, introduction }) => ({
          img,
          title,
          introduction,
          to: `${this.path}/${formatToURL(title)}-${id}`,
        }));
      })
      .then(() => (this.loading = false));
  },
  components: {
    LoadingWidget,
    ProductCard,
    ButtonWidget,
  },
};
</script>
